var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 401 c-51 -24 -82 -47 -73 -56 3 -4 23 5 45 19 70 46 160 47 228 0 21 -14 40 -23 42 -20 21 21 -94 76 -157 76 -25 0 -63 -9 -85 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 278 c0 -7 11 -26 24 -43 l25 -30 -32 -32 c-41 -43 -26 -56 17 -14 33 32 34 32 60 16 l25 -17 -19 -39 c-22 -43 -24 -49 -12 -49 5 0 17 18 27 40 19 41 24 44 63 34 18 -5 22 -13 22 -50 0 -24 5 -44 10 -44 6 0 10 20 10 45 0 29 4 45 13 45 6 0 21 3 33 6 16 4 24 -2 39 -35 10 -23 22 -41 27 -41 11 0 10 2 -7 43 -20 47 -19 52 8 64 19 9 27 6 54 -20 43 -40 56 -26 16 16 l-32 32 25 30 c45 56 24 57 -28 2 -77 -81 -151 -97 -243 -53 -47 21 -105 75 -105 97 0 5 -4 9 -10 9 -5 0 -10 -6 -10 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closed-eye.6bfe7230b42140276c754664a42e0cdb.svg";
export { ForwardRef as ReactComponent };